import { QuestionnaireFormProps } from '@getpopsure/qnr-framework';
import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { flushGenericQuestionnaire } from 'actions/genericQuestionnaire';
import routes from 'constants/routes';
import { createQuote } from 'features/dental/actions';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useSafeTranslation } from 'shared/i18n';
import { RequestProcessing } from 'SignupQuestionnaire/components/Processing/RequestProcessing';

import { Dental } from '../../models';

export const QuoteProcessing = ({
  questionnaireAnswers,
  onSubmitValue,
}: QuestionnaireFormProps<Dental>) => {
  const { t } = useSafeTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const { mutateAsync: submitQuotes } = useMutation({
    mutationFn: () => {
      const { dateOfBirth, publicInsurer } = questionnaireAnswers;

      if (!dateOfBirth || !publicInsurer) {
        throw new Error('Missing fields required to fetch Dental quote');
      }

      return createQuote(dateOfBirth, publicInsurer.value);
    },
    onSuccess: ({ data: quotes }) => {
      onSubmitValue([...quotes]);
    },
    onError: (error) => {
      Sentry.captureException(error, {
        tags: {
          feature: 'QUOTE',
          vertical: 'DENTAL',
        },
        extra: {
          description: 'Error happened while fetching Dental quotes',
        },
      });
    },
  });

  const textList: string[] = [
    t(
      'dental.qnr.preQuote.quote.processing.loadingText',
      'Preparing your options'
    ),
  ];

  const description: string = t(
    'dental.qnr.preQuote.quoteProcessing.description',
    "We're preparing the best options based on the answers you provided."
  );

  const handleErrorRecovery = () => {
    dispatch(flushGenericQuestionnaire('dentalV2'));
    history.push(routes.policies.dental.path);
  };

  return (
    <RequestProcessing
      textList={textList}
      description={description}
      requestFn={submitQuotes}
      handleErrorRecovery={handleErrorRecovery}
      shouldSubmitScreen={false}
    />
  );
};
